import { useEffect, useState } from 'react';
import styled from 'styled-components';
import useConfiguration from '~/configuration/use-configuration';

const Svg = styled.svg`
	object-fit: fill;
`;

Svg.defaultProps = {
	height: 24,
	width: 24
};

const CUSTOM_MAPPINGS = {
	galaksino: {
		'shop-line': 'satellite',
		'crown-line': 'atom'
	},
	sunmaker: {
		'welcome-screen': { type: 'welcome-screen', height: '46', width: '101' }
	}
};

const mapIconType = (siteCode, type) => {
	const mapped = CUSTOM_MAPPINGS[siteCode]?.[type] ?? type;
	return typeof mapped === 'string' || mapped instanceof String ? { type: mapped } : mapped;
};

/**
 * @typedef {Object} IconProps
 * @property {string} type
 * @property {string=} className
 * @property {string|number=} width
 * @property {string|number=} height
 */
/**
 * @param {IconProps} props
 */
const Icon = props => {
	const { siteCode } = useConfiguration();
	const { type, className = '', width = '24', height = '24' } = { ...props, ...mapIconType(siteCode, props.type) };

	const [importedIcon, setImportedIcon] = useState(null);

	useEffect(() => {
		const importComponent = async () => {
			try {
				const module = await import(`./svg-icons/${type}.tsx`);
				const SVG = module.default;
				setImportedIcon(<SVG className={`${className} icon--sprite`} width={width} height={height} />);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(error);
				setImportedIcon(null);
			}
		};

		importComponent();
	}, [className, height, type, width]);

	return importedIcon;
};

export default Icon;
